import {
  initialState,
  Actions,
  State,
  GET_ALL_INVITATIONS,
  GET_ALL_INVITATIONS_SUCCESS,
  GET_ALL_INVITATIONS_ERROR,
  RESET_GET_ALL_INVITATIONS,
  UPDATE_INVITATIONS,
} from '../../types/invitation/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_INVITATIONS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_INVITATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_INVITATIONS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case UPDATE_INVITATIONS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      }
    case RESET_GET_ALL_INVITATIONS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
